"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _CRMToContactsObjectTypes = _interopRequireDefault(require("crm_data/constants/CRMToContactsObjectTypes"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _UserPortalSettingsKe;

var _portalId = _hubspot.default.get();

var EMAIL_CLIENT_SETTINGS_OBJECT_TYPE = 'EMAIL_CLIENT_SETTINGS';
/**
 * Keys for users in a specific portal.
 * The portalId will be appended to the end of the key.
 *
 * If you need a key for cross-portal settings, see
 * crm_data/settings/UserSettingsKeys
 */

var UserPortalSettingsKeys = (_UserPortalSettingsKe = {
  EMAIL_CLIENT_SETTINGS: [EMAIL_CLIENT_SETTINGS_OBJECT_TYPE],
  EMAIL_UNSUBSCRIBE_LINK_TYPE: ['hubspot', 'gdpr', 'unsubscribe-link'],
  ONBOARDING_SETTINGS: ['onboarding', 'onboarding-settings'],
  SALES_SEGMENTATION: ['onboarding', 'sales-segmentation'],
  SEGMENTS_FOLDERS_LAST_VIEWED: ['segments-folders-last-viewed'],
  SEGMENTS_DISMISSED_STALE_LIST_EXPLANATION: ['segments-folders-dismissed-stale-list-explanation'],
  SIGNEDUP_VIA_SPACESWORD: ['viaSpacesword'],
  TIP_POPOVER_SETTINGS: ['onboarding', 'onboarding-tip-popovers']
}, (0, _defineProperty2.default)(_UserPortalSettingsKe, "COLUMN_FAVS_" + _ObjectTypes.TASK, [_CRMToContactsObjectTypes.default[_ObjectTypes.TASK], 'FavoriteColumns_V2']), (0, _defineProperty2.default)(_UserPortalSettingsKe, "COLUMN_FAVS_" + _ObjectTypes.VISIT, [_CRMToContactsObjectTypes.default[_ObjectTypes.VISIT], 'FavoriteColumns']), (0, _defineProperty2.default)(_UserPortalSettingsKe, "RECENTLY_USED_PROPERTIES_" + _ObjectTypes.VISIT, [_CRMToContactsObjectTypes.default[_ObjectTypes.VISIT], 'recently-used-properties']), (0, _defineProperty2.default)(_UserPortalSettingsKe, "HIDE_EMAIL_IMPORT_FOR_CONTACT", ['hide-email-import-for-contact']), (0, _defineProperty2.default)(_UserPortalSettingsKe, "HIDE_EMAIL_IMPORT_FOR_ALL", ['hide-email-import-for-all']), (0, _defineProperty2.default)(_UserPortalSettingsKe, "DISMISSED_TRANSCRIPT_SUGGESTIONS", ['dismissed-transcript-suggestions']), _UserPortalSettingsKe); // Settings keys that have are associated w/ all major object types

var MAJOR_OBJECT_TYPES = [_ObjectTypes.CONTACT, _ObjectTypes.COMPANY, _ObjectTypes.DEAL, _ObjectTypes.TICKET];
MAJOR_OBJECT_TYPES.forEach(function (objectType) {
  UserPortalSettingsKeys["TIMELINE_FAVS_" + objectType] = [_CRMToContactsObjectTypes.default[objectType], 'FavoriteTimelineEvents'];
  UserPortalSettingsKeys["COLUMN_FAVS_" + objectType] = [_CRMToContactsObjectTypes.default[objectType], 'FavoriteColumns'];
  UserPortalSettingsKeys["PROPERTY_EDITOR_HIDE_BLANK_" + objectType] = [_CRMToContactsObjectTypes.default[objectType], 'property_editor_hide_blank'];
  UserPortalSettingsKeys["PROPERTY_EDITOR_OPEN_GROUPS_" + objectType] = [_CRMToContactsObjectTypes.default[objectType], 'property_editor_open_groups'];
  UserPortalSettingsKeys["RECENTLY_USED_PROPERTIES_" + objectType] = [_CRMToContactsObjectTypes.default[objectType], 'recently-used-properties'];
}); // Formats like "ONBOARDING:onboarding-settings:123456"

Object.keys(UserPortalSettingsKeys).forEach(function (key) {
  var value = UserPortalSettingsKeys[key];
  UserPortalSettingsKeys[key] = value.join(':') + ":" + _portalId;
});
var _default = UserPortalSettingsKeys;
exports.default = _default;
module.exports = exports.default;